/* Graph of Life brand v1.1.0 · tokens.json */
import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Coral is reserved for risk, fragility and explicit caveats.
export const CaveatCallout = ({ label = 'Current limit', children, testId }) => (
  <div
    data-testid={testId}
    className="relative flex gap-3 border-l-2 border-risk-base bg-risk-deep/25 px-4 py-3 rounded-sm backdrop-blur-sm"
  >
    <AlertTriangle size={14} className="text-risk-bright shrink-0 mt-0.5" aria-hidden="true" />
    <div className="space-y-1">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-risk-bright">{label}</p>
      <p className="text-sm leading-relaxed text-sand-50/70">{children}</p>
    </div>
  </div>
);

export default CaveatCallout;
